import { getMerchant } from '../helpers/ReduxHelpers';

// Per-merchant branded tracking subdomains on proship.in. 't' is the default tracking app
// (https://t.proship.in/<awb>). Keep in sync with the Track action in AllOrders.js.
export const MERCHANT_TRACKING_DOMAINS = {
  '67470509d56298539d20d8f7': 'atovio',
  '669e35c34731fe7eb440a029': 'baidyanathayurved',
  '6814a1d2ecd5fc2c7d8b5d36': 'maapooja',
  '67ea37e8a7208d75355e5959': 'pairietales',
  '67b438fe8579731d83072d3e': 'zwende',
};

/**
 * Public, buyer-facing tracking URL for an AWB — the standalone proship.in tracking app
 * (a merchant's branded subdomain if configured, else the default 't'). This is a shareable
 * link a merchant can send to a buyer; it opens the public tracking site, not the panel.
 */
export function getTrackingUrl(awb, merchantId) {
  const id = merchantId || getMerchant()?.id;
  const domain = MERCHANT_TRACKING_DOMAINS[id] || 't';
  return `https://${domain}.proship.in/${awb}`;
}
